<div class="row dashboardBlock">
  <div class="col-12">
    <div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
      <div class="col-sm-2 col-md-3 padding-menu">
        <div class="actionItemsList">
          <ul>
            <ng-container *ngFor="let item of finesList; let i = index">
              <li *ngIf="item.isShow"
                [ngClass]="item.isActive ? (isArabic ? 'active arabicAlign' : 'active') : (isArabic ? 'cursor-pointer arabicAlign' : 'cursor-pointer')"
                (click)="onListItemClick(i)">
                <span class="stepNumber">
                  <img [src]="item.img" alt="" />
                </span>
                <span class="stepText" *ngIf="!isArabic">{{ item.value }}</span>
                <span class="stepText" *ngIf="isArabic">{{ item.arabicValue }}</span>
                <div *ngIf="item.link == 'fines/active' && finesCount" class="item-count"
                [ngClass]="isArabic ? 'arabicCount' : ''">{{finesCount}}</div>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
      <div class="col-sm-10 col-md-9 assessment-right">
        <div><router-outlet></router-outlet></div>
      </div>
    </div>
  </div>
</div>